import { createAction, createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("POLICY_PROGNOSIS"),
	...createAction("RESET_PROGNOSIS"),
};
